import FreeResponseInput from 'modules/IndustryPartnerProgramExploration/components/Evaluation/components/FreeResponseInput';
import MultiSelectInput from 'modules/IndustryPartnerProgramExploration/components/Evaluation/components/MultiSelectInput';
import ScaleInput from 'modules/IndustryPartnerProgramExploration/components/Evaluation/components/ScaleInput';
import SignatureInput from 'modules/IndustryPartnerProgramExploration/components/Evaluation/components/SignatureInput';
import SingleSelectInput from 'modules/IndustryPartnerProgramExploration/components/Evaluation/components/SingleSelectInput';

export const PROGRAMS_PAGE_SLUG = 'all-programs';
export const PLATFORM_PROGRAMS_PAGE_SLUG = 'platform-programs';
export const BASE_CANDIDATE_URL = '/program-exploration/candidate/';

export const APPLICATIONS_PAGE_SLUG = 'applications';

export const OPPORTUNITIES_PAGE_SLUG = 'opportunities';
export const PLACEMENTS_PAGE_SLUG = 'placements';
export const PLACEMENT_DETAILS_PAGE_SLUG = 'placement-details';

export const BOOLEAN = 'boolean';
export const FREE_RESPONSE = 'free_response';
export const FREE_RESPONSE_MULTILINE = 'free_response_multiline';
export const MULTI_SELECT = 'multi_select';
export const SCALE = 'scale';
export const SIGNATURE = 'signature';
export const SINGLE_SELECT = 'single_select';
export const ADDITIONAL_QUESTION = 'additional_question';
export const FILE = 'file';

export const EVALUATION_INPUT_MAP = {
  [FREE_RESPONSE]: FreeResponseInput,
  [FREE_RESPONSE_MULTILINE]: FreeResponseInput,
  [MULTI_SELECT]: MultiSelectInput,
  [SCALE]: ScaleInput,
  [SIGNATURE]: SignatureInput,
  [SINGLE_SELECT]: SingleSelectInput,
};

export const INTRODUCTION = 'introduction';
export const OPPORTUNITY = 'opportunity';
export const SPONSOR = 'sponsor';
export const CANDIDATE = 'candidate';
export const REVIEW = 'review';

export const BYOP_STEPS_MAP = {
  [INTRODUCTION]: INTRODUCTION,
  [SPONSOR]: SPONSOR,
  [OPPORTUNITY]: OPPORTUNITY,
  [CANDIDATE]: CANDIDATE,
  [REVIEW]: REVIEW,
};

export const PENDING_PM_APPROVAL = 'pending_pm_approval';
export const SPONSOR_INVITE_BOUNCED = 'sponsor_invite_bounced';
export const PENDING_SPONSOR_ACCEPTANCE = 'pending_sponsor_acceptance';
export const PENDING_SUBMISSION = 'pending_submission';
export const COMPLETE = 'complete';
export const PUBLISHED = 'published';
export const NOT_PUBLISHED = 'not_published';
export const PUBLISHED_FOR_CANDIDATE = 'published_for_candidate';
export const PUBLISHED_FOR_SPONSOR = 'published_for_sponsor';

export const APPLICATION_STATUSES = [
  PENDING_SUBMISSION,
  PENDING_SPONSOR_ACCEPTANCE,
  PENDING_PM_APPROVAL,
  SPONSOR_INVITE_BOUNCED,
];

export const CANDIDATE_OBJECT = 'candidate';
export const OPPORTUNITY_OBJECT = 'opportunity';

export const FREE_RESPONSE_OBJECT = 'freeResponses';
export const DATE_RESPONSE_OBJECT = 'dateResponses';

export const SPONSOR_OBJECT = 'sponsor';

export const STAFF = 'staff';

export const CUSTOM_FIELD_PREFIX = 'field_';

export const INVALID_INPUT_ERROR_MESSAGE = 'Invalid input.';

export const CANDIDATE_SEARCH_HEADER_TEXT =
  'Discover and apply to programs managed by your district and organizations around the country.';

export const CANDIDATE_SEARCH_PLACEHOLDER = 'Search for programs by name';

export const SPONSOR_SEARCH_HEADER_TEXT =
  'Discover programs managed by school districts and organizations around the country.';

export const SPONSOR_SEARCH_SUBHEADING =
  'Submit opportunities to have candidates placed at your organization.';

export const SPONSOR_SEARCH_PLACEHOLDER = 'Search by program, org, or district';
